module.exports = __webpack_public_path__ + "img/zffw2.b6d944e1.png";